import { Editor, Location, Element as SlateElement } from 'slate'

import { BLOCK_FORMATS } from '../../interface/custom-types'

import { isEmptyBlockHelper } from './../isEmptyBlockHelper'

const checkIfInTable = (editor: Editor, at?: Location) => {
  return !!Editor.above(editor, {
    at,
    match: (node) => SlateElement.isElement(node) && node.type === BLOCK_FORMATS.table,
  })
}

export const behaviorForTable = (editor: Editor) => {
  if (!editor.selection) {
    return
  }

  const isInTable = checkIfInTable(editor)
  const pathBeforeLine = Editor.before(editor, editor.selection)
  const isLineBeforeTable = checkIfInTable(editor, pathBeforeLine)

  // We prohibit erasing the line after the table so that we can edit the content after the table
  const isEmptyLine = !Editor.string(editor, editor.selection)
  if (isLineBeforeTable && isEmptyLine && !isInTable) {
    return true
  }

  if (isInTable) {
    const start = Editor.start(editor, editor.selection)
    const isStart = Editor.isStart(editor, start, editor.selection)

    const currCell = Editor.above(editor, {
      match: (node) => SlateElement.isElement(node) && node.type === BLOCK_FORMATS.tableCell,
    })

    if (currCell) {
      // The check associated with childrenNodes is needed to make it possible to erase empty lines inside cells
      const isEmptyBlock = isEmptyBlockHelper(editor, currCell[1])
      if (isStart && isEmptyBlock) {
        return true
      }
    }
  }

  return false
}
